// const api_host = "http://localhost:8000"
const api_host = "http://glycopeptideatlas-eb-env.eba-zxebtsmp.us-west-2.elasticbeanstalk.com"

export const sampleGlycogeneHeatMapData = [
    { name: 'Metric1', data: [45, 52, 38, 24, 33, 10, 20, 30, 45, 50] },
    { name: 'Metric2', data: [35, 41, 36, 26, 45, 48, 52, 53, 41] },
    { name: 'Metric3', data: [10, 52, 55, 61, 64, 69, 71, 78, 95] },
    { name: 'Metric4', data: [47, 45, 74, 32, 56, 31, 44, 33, 45, 19] },
    { name: 'Metric5', data: [63, 67, 52, 62, 73, 45, 55, 54, 61, 48, 49, 56] },
  ];

export const sampleGlycogeneHeatMapOptions = {
    chart: {
      type: 'heatmap',
      height: 350,
    },
    dataLabels: {
      enabled: false,
    },

    title: {
      text: 'Heatmap Chart for PanCancer Glycogenes'
    },
    xaxis: {
      type: 'category',
      categories: ['C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'C8', 'C9', 'C10'],
    },
    yaxis: {
      title: {
        text: 'Projects'
      }
    },
    plotOptions: {
        heatmap: {
          shadeIntensity: 1,
          colorScale: {
            ranges: [
                { from: -Infinity, to: -1, color: '#0000FF' },  // Deep blue for -Infinity to -1
                { from: -1, to: -0.8, color: '#0000FF' },
                { from: -0.8, to: -0.6, color: '#3366FF' },
                { from: -0.6, to: -0.4, color: '#66CCFF' },
                { from: -0.4, to: -0.2, color: '#99CCFF' },
                { from: -0.2, to: -0.1, color: '#FFFFFF' },
                { from: -0.1, to: 0.1, color: '#FFFFFF' },  // Pure white for -0.1 to 0.1
                { from: 0.1, to: 0.2, color: '#FFCCCC' },
                { from: 0.2, to: 0.4, color: '#FF9999' },
                { from: 0.4, to: 0.6, color: '#FF6666' },
                { from: 0.6, to: 0.8, color: '#FF3333' },
                { from: 0.8, to: 1, color: '#FF0000' },
                { from: 1, to: Infinity, color: '#FF0000' }  // Deep red for 1 to Infinity
              ],
          },
          useFillColorAsStroke: true
        }
      }
  };

export async function fetchGlycogeneHeatMapData(){
    try {
  
      const api_path = `/api/get-glycogene-heatmap-data/`;
      const full_api_path = `${api_host}${api_path}`
      const response = await fetch(full_api_path);
      const data = await response.json();
  
      return data;
  
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }